import React from 'react';
import Hero from '../components/Hero';
import FeaturedClinics from '../components/FeaturedClinics';
import Specialties from '../components/Specialties';
import ClinicsDirectory from '../components/ClinicsDirectory';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <div>
      <Hero />
      <FeaturedClinics />
      <Specialties />
      <ClinicsDirectory />
      <CTASection />
    </div>
  );
};

export default Home;
